<app-page-headline
        [breadcrumbTitle]="'Branchenübersicht'"
        [breadcrumbs]="[
        { label: 'Startseite', link: '/' },
        { label: 'Branchenübersicht', iconClass: 'fa fa-angle-double-right', link: '/liste-konfigurieren' }]"
        [mainTitle]="'Alle verfügbaren Branchen'"
        [subtitle]="'Hier finden Sie eine Übersicht aller Branchen, für die auf dieser Plattform Unternehmensdaten vorliegen.\n'+
                        ' Sie die Filter- und Suchoptionen, um gezielt nach bestimmten Branchen oder Datensätzen zu suchen.'"
        [titleImagePath]="'assets/images/saas1/title-logo.png'"
        [backgroundImage]="'assets/images/saas1/work-bg.png'">
</app-page-headline>
<section class="container mt-5">
    <!-- Suchleiste -->
    <div class="row justify-content-center mb-4">
        <div class="col-md-6">
            <input
                    type="text"
                    class="form-control form-control-lg shadow-sm"
                    placeholder="Branche oder Schlagwort suchen..."
                    [(ngModel)]="searchTerm" />
        </div>
    </div>
    <!-- Info-Banner -->
    <div class="container mb-4">
        <div class="row">
            <div class="col-12">
                <div class="bg-light shadow-sm rounded-3 p-4 d-flex align-items-center gap-3">
                    <div>
                        <h4 class="mb-1">Entdecken Sie <b>{{ INDUSTRY_OVERVIEW_STATIC_OBJECTS.length }}</b> Branchen</h4>
                        <span class="text-muted fs-6">
                          Insgesamt stehen Ihnen <b>{{ totalRowCount | number:'1.0-0' }}</b> Datensätze zur Verfügung.
                          Wählen Sie gezielt Branchen und Filter aus und konfigurieren Sie Ihr individuelles Datenpaket – schnell, einfach und passgenau auf Ihre Bedürfnisse zugeschnitten.
                        </span>
                    </div>
                    <div class="ms-auto d-flex align-items-center">
                        <label class="me-2 mb-0">Sortierung:</label>
                        <select class="form-select d-inline-block w-auto" [(ngModel)]="sortDirection" (change)="sortBranchen()">
                            <option value="az">Name aufsteigend</option>
                            <option value="za">Name absteigend</option>
                            <option value="len-asc">Anzahl Aufsteigend</option>
                            <option value="len-desc">Anzahl Absteigend</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Branchenübersicht Grid -->
    <div class="row g-4">
        <div
                class="col-12 col-sm-6 col-md-4 col-lg-3"
                *ngFor="let branche of filteredBranchen">
            <a
                    [routerLink]="['/liste-konfigurieren']"
                    class="text-decoration-none text-dark"
            >
                <div class="card h-100 border rounded shadow-sm">
                    <img
                            [src]="branche.thumbnail || 'assets/images/industry_overview/Architekten.webp'"
                            class="card-img-top"
                            alt="{{ branche.name }}"
                            style="object-fit: cover; height: 160px;"
                    />
                    <div class="card-body d-flex flex-column">
                        <h5 class="card-title">{{ branche.name }}</h5>
                        <p class="card-text text-muted mt-auto">
                            {{ branche.rowCount }} verfügbare Unternehmen
                        </p>
                    </div>
                </div>
            </a>
        </div>
        <div class="row justify-content-center">
            <div class="col-6 rounded-5 border border-1 mt-5">
                <div *ngIf="filteredBranchen.length === 0" class="d-flex align-items-center justify-content-between p-4 mb-4 fade show" role="alert" style="min-height: 120px;">
                    <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 gap-md-4">
                        <i class="fa fa-search-minus fa-2x text-warning"></i>
                        <div>
                            <h5 class="mb-1 fw-semibold">Konnten Sie Ihre Branche nicht finden?</h5>
                            <span class="text-muted">Kontaktieren Sie uns – wir unterstützen Sie gerne dabei, individuelle Branchendaten bereitzustellen.</span>
                        </div>
                    </div>
                    <a routerLink="/kontakt" class="btn btn-primary btn-lg ms-md-5 mt-3 mt-md-0">
                        Kontakt
                        <i class="fa fa-arrow-right ms-2"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="mb-5"></div>
</section>
